
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { useLanguage } from '../../../../contexts/language';

interface ResetViewButtonProps {
  onClick: () => void;
}

const ResetViewButton: React.FC<ResetViewButtonProps> = ({ onClick }) => {
  const { t } = useLanguage();

  return (
    <Button 
      variant="outline" 
      size="sm" 
      className="absolute bottom-2 right-2 bg-white/80 backdrop-blur-sm hover:bg-white text-xs py-1 shadow-md"
      onClick={onClick}
    >
      <RefreshCw className="h-3 w-3 mr-1" />
      {t('resetView')}
    </Button>
  );
};

export default ResetViewButton;
